module.exports = __webpack_public_path__ + "img/shape6.647dc073.svg";